export default "__VITE_ASSET__B1fclvF4__"